// src/config/api.js

import { REACT_APP_API_BASE_URL } from "../config";

export const BASE_URL = REACT_APP_API_BASE_URL;